// import axios from "axios";
// import { getCookie, setCookie } from "../../../lib/cookie.js";
// export const BASE_URL = import.meta.env.VITE_BASE_URL;
// const api = axios.create({
//   baseURL: BASE_URL,
//   headers: {
//     "Content-Type": "application/json",
//   },
//   withCredentials: true,
// });

// const publicRoutes = [
//   "User/SendOtp",
//   "User/ConfirmOtp",
// ];

// api.interceptors.request.use((config: any) => {
//   let accessTokenCartStreet = getCookie("accessTokenCartStreet");
//   if (!accessTokenCartStreet && typeof window !== "undefined") {
//     accessTokenCartStreet = localStorage.getItem("accessTokenCartStreet") || "";
//   }
//   const isPublic = publicRoutes.some((route) =>
//     config.url?.includes(route)
//   );

//   if (!isPublic && accessTokenCartStreet) {
//     config.headers["Authorization"] = `Bearer ${accessTokenCartStreet}`;
//   }

//   return config;
// }, (error) => {
//   return Promise.reject(error);
// });

// api.interceptors.response.use(
//   (response) => response,
//   async (error) => {
//     const originalRequest = error.config;

//     if (error?.response?.status === 401 && !originalRequest._retry) {
//       originalRequest._retry = true;

//       try {
//         const res = await getNewTokens();

//         if (res?.accessTokenCartStreet) {
//           setCookie("accessTokenCartStreet", res.accessTokenCartStreet, 30);
//           setCookie("refreshToken", res.refreshToken, 360);

//           originalRequest.headers["Authorization"] = `Bearer ${res.accessTokenCartStreet}`;
//           return api(originalRequest);
//         } else {
//           // clearTokens();
//         }
//       } catch {
//         // clearTokens();
//       }
//     }

//     return Promise.reject(error?.response?.data || error.message);
//   }
// );

// export default api;



// const getNewTokens = async () => {
//   const refreshToken = getCookie("refreshToken");
//   if (!refreshToken) return {};

//   try {
//     const res = await axios.post(`${import.meta.env.VITE_BASE_URL}auth/refresh-token`, {
//       refresh_token: refreshToken,
//     });

//     return res?.data || {};
//   } catch {
//     return {};
//   }
// };

// // const clearTokens = () => {
// //   setCookie("accessTokenCartStreet", "", 0);
// //   setCookie("refreshToken", "", 0);
// // };












// import axios from "axios";
// import { getCookie, setCookie } from "../../../lib/cookie.js";

// export const BASE_URL = import.meta.env.VITE_BASE_URL;

// const api = axios.create({
//   baseURL: BASE_URL,
//   headers: {
//     "Content-Type": "application/json",
//   },
//   withCredentials: true,
// });

// const publicRoutes = [
//   "User/SendOtp",
//   "User/ConfirmOtp",
//   "shopPanel/sendOtp",
//   "shopPanel/validateOtp",
// ];

// api.interceptors.request.use((config: any) => {
//   let accessTokenCartStreet = getCookie("accessTokenCartStreet");
//   if (!accessTokenCartStreet && typeof window !== "undefined") {
//     accessTokenCartStreet = localStorage.getItem("accessTokenCartStreet") || "";
//   }
//   const isPublic = publicRoutes.some((route) =>
//     config.url?.includes(route)
//   );
//   if (!isPublic && accessTokenCartStreet) {
//     config.headers["Authorization"] = `Bearer ${accessTokenCartStreet}`;
//   }
//   return config;
// }, (error) => {
//   return Promise.reject(error);
// });

// api.interceptors.response.use(
//   (response) => {
//     const authHeader = response.headers.authorization 
//       || response.headers.Authorization 
//       || response.headers.get("authorization")
//       || response.headers.get("Authorization");

//     if (authHeader) {
//       const token = authHeader.replace('Bearer ', '');
//       if (token) {
//         setCookie("accessTokenCartStreet", token, 30);
//         if (typeof window !== "undefined") {
//           localStorage.setItem("accessTokenCartStreet", token);
//         }
//       }
//     }

//     return response;
//   },
//   async (error) => {
//     const originalRequest = error.config;
//     if (error?.response?.status === 401 && !originalRequest._retry) {
//       originalRequest._retry = true;
//       try {
//         const res = await getNewTokens();
//         if (res?.accessTokenCartStreet) {
//           setCookie("accessTokenCartStreet", res.accessTokenCartStreet, 30);
//           setCookie("refreshToken", res.refreshToken, 360);
//           originalRequest.headers["Authorization"] = `Bearer ${res.accessTokenCartStreet}`;
//           return api(originalRequest);
//         } else {
//           // clearTokens();
//         }
//       } catch {
//         // clearTokens();
//       }
//     }
//     return Promise.reject(error?.response?.data || error.message);
//   }
// );

// export default api;

// const getNewTokens = async () => {
//   const refreshToken = getCookie("refreshToken");
//   if (!refreshToken) return {};
//   try {
//     const res = await axios.post(`${import.meta.env.VITE_BASE_URL}auth/refresh-token`, {
//       refresh_token: refreshToken,
//     });
//     return res?.data || {};
//   } catch {
//     return {};
//   }
// };







// import axios from "axios";
// import { getCookie, setCookie } from "../../../lib/cookie.js";

// export const BASE_URL = import.meta.env.VITE_BASE_URL;

// const api = axios.create({
//   baseURL: BASE_URL,
//   headers: {
//     "Content-Type": "application/json",
//   },
//   withCredentials: true,
// });

// const publicRoutes = [
//   "User/SendOtp",
//   "User/ConfirmOtp",
//   "customerPanel/login/sendOtp",
//   "customerPanel/login/validateOTP",
// ];

// const tokenReturningRoutes = [
//   "customerPanel/login/validateOTP",  
// ];

// api.interceptors.request.use((config: any) => {
//   let accessTokenCartStreet = getCookie("accessTokenCartStreet");
//   if (!accessTokenCartStreet && typeof window !== "undefined") {
//     accessTokenCartStreet = localStorage.getItem("accessTokenCartStreet") || "";
//   }
//   const isPublic = publicRoutes.some((route) =>
//     config.url?.includes(route)
//   );
//   if (!isPublic && accessTokenCartStreet) {
//     config.headers["Authorization"] = `Bearer ${accessTokenCartStreet}`; 
//   }
//   return config;
// }, (error) => {
//   return Promise.reject(error);
// });

// api.interceptors.response.use(
//   (response) => {
//     const url = response.config?.url || "";

//     const isTokenRoute = tokenReturningRoutes.some((route) => url.includes(route));

//     if (isTokenRoute) {
//       const authHeader = response.headers["authorization"] || response.headers["Authorization"];

//       if (authHeader && typeof authHeader === "string") {
//         let token = authHeader;
//         if (token.startsWith("Bearer ")) {
//           token = token.substring(7);
//         }

//         setCookie("accessTokenCartStreet", token, 30);
//         localStorage.setItem("accessTokenCartStreet", token);
//       }
//     }

//     return response;
//   },
//   async (error) => {
//     const originalRequest = error.config;
//     if (error?.response?.status === 401 && !originalRequest._retry) {
//       originalRequest._retry = true;
//       try {
//         const res = await getNewTokens();
//         if (res?.accessTokenCartStreet) {
//           setCookie("accessTokenCartStreet", res.accessTokenCartStreet, 30);
//           setCookie("refreshToken", res.refreshToken, 360);
//           originalRequest.headers["Authorization"] = `Bearer ${res.accessTokenCartStreet}`;
//           return api(originalRequest);
//         }
//       } catch {
//         //  refresh token
//       }
//     }
//     return Promise.reject(error?.response?.data || error.message);
//   }
// );

// export default api;

// const getNewTokens = async () => {
//   const refreshToken = getCookie("refreshToken");
//   if (!refreshToken) return {};
//   try {
//     const res = await axios.post(`${import.meta.env.VITE_BASE_URL}auth/refresh-token`, {
//       refresh_token: refreshToken,
//     });
//     return res?.data || {};
//   } catch {
//     return {};
//   }
// };


// import axios from "axios";
// import { getCookie, setCookie } from "../../../lib/cookie.js";

// export const BASE_URL = import.meta.env.VITE_BASE_URL;

// const api = axios.create({
//   baseURL: BASE_URL,
//   headers: {
//     "Content-Type": "application/json",
//   },
//   withCredentials: true,
// });

// const getBaseURL = () => {
//   if (import.meta.env.PROD && !import.meta.env.VITE_USE_PROXY) {
//     return ''; 
//   }
//   return BASE_URL;
// };

// const publicRoutes = [
//   "User/SendOtp",
//   "User/ConfirmOtp", 
//   "customerPanel/login/sendOtp",
//   "customerPanel/login/validateOTP",
// ];

// const tokenReturningRoutes = [
//   "customerPanel/login/validateOTP",  
// ];

// api.interceptors.request.use((config: any) => {
//   let accessTokenCartStreet = getCookie("accessTokenCartStreet");
//   if (!accessTokenCartStreet && typeof window !== "undefined") {
//     accessTokenCartStreet = localStorage.getItem("accessTokenCartStreet") || "";
//   }
//   const isPublic = publicRoutes.some((route) =>
//     config.url?.includes(route)
//   );
//   if (!isPublic && accessTokenCartStreet) {
//     config.headers["Authorization"] = `Bearer ${accessTokenCartStreet}`; 
//   }
//   return config;
// }, (error) => {
//   return Promise.reject(error);
// });

// api.interceptors.response.use(
//   (response) => {
//     const url = response.config?.url || "";
//     const isTokenRoute = tokenReturningRoutes.some((route) => url.includes(route));

//     if (isTokenRoute) {
//       const authHeader = response.headers["authorization"] || response.headers["Authorization"];
//       if (authHeader && typeof authHeader === "string") {
//         let token = authHeader;
//         if (token.startsWith("Bearer ")) {
//           token = token.substring(7);
//         }
//         setCookie("accessTokenCartStreet", token, 30);
//         localStorage.setItem("accessTokenCartStreet", token);
//       }
//     }
//     return response;
//   },
//   async (error) => {
//     const originalRequest = error.config;
//     if (error?.response?.status === 401 && !originalRequest._retry) {
//       originalRequest._retry = true;
//       try {
//         const res = await getNewTokens();
//         if (res?.accessTokenCartStreet) {
//           setCookie("accessTokenCartStreet", res.accessTokenCartStreet, 30);
//           setCookie("refreshToken", res.refreshToken, 360);
//           originalRequest.headers["Authorization"] = `Bearer ${res.accessTokenCartStreet}`;
//           return api(originalRequest);
//         }
//       } catch {
//         // refresh token failed
//       }
//     }
//     return Promise.reject(error?.response?.data || error.message);
//   }
// );

// export default api;

// const getNewTokens = async () => {
//   const refreshToken = getCookie("refreshToken");
//   if (!refreshToken) return {};

//   const baseURL = getBaseURL();
//   try {
//     const res = await axios.post(`${baseURL}/auth/refresh-token`, {
//       refresh_token: refreshToken,
//     });
//     return res?.data || {};
//   } catch {
//     return {};
//   }
// };


// import axios from "axios";
// import { getCookie, setCookie } from "../../../lib/cookie.js";

// export const BASE_URL = import.meta.env.VITE_BASE_URL;

// const api = axios.create({
//   baseURL: BASE_URL,
//   timeout: 15000,
//   headers: {
//     "Content-Type": "application/json",
//   },
//   withCredentials: true,
// });

// const publicRoutes = [
//   "User/SendOtp",
//   "User/ConfirmOtp", 
//   "customerPanel/login/sendOtp",
//   "customerPanel/login/validateOTP",
// ];

// const tokenReturningRoutes = [
//   "customerPanel/login/validateOTP",  
// ];

// // اینترسپتور درخواست
// api.interceptors.request.use((config: any) => {
//   let accessTokenCartStreet = getCookie("accessTokenCartStreet");
//   if (!accessTokenCartStreet && typeof window !== "undefined") {
//     accessTokenCartStreet = localStorage.getItem("accessTokenCartStreet") || "";
//   }

//   const isPublic = publicRoutes.some((route) =>
//     config.url?.includes(route)
//   );

//   if (!isPublic && accessTokenCartStreet) {
//     // ✅ با Bearer
//     config.headers["Authorization"] = `Bearer ${accessTokenCartStreet}`; 
//   }

//   return config;
// }, (error) => {
//   return Promise.reject(error);
// });

// // اینترسپتور پاسخ
// api.interceptors.response.use(
//   (response) => {
//     const url = response.config?.url || "";
//     const isTokenRoute = tokenReturningRoutes.some((route) => url.includes(route));

//     if (isTokenRoute) {
//       const authHeader = response.headers["authorization"] || response.headers["Authorization"];
//       if (authHeader && typeof authHeader === "string") {
//         let token = authHeader;
//         // حذف Bearer اگه باشه
//         if (token.startsWith("Bearer ")) {
//           token = token.substring(7);
//         }
//         setCookie("accessTokenCartStreet", token, 30);
//         localStorage.setItem("accessTokenCartStreet", token);
//       }
//     }
//     return response;
//   },
//   async (error) => {
//     const originalRequest = error.config;

//     // 401 error - تلاش برای refresh token
//     if (error?.response?.status === 401 && !originalRequest._retry) {
//       originalRequest._retry = true;
//       try {
//         const res = await getNewTokens();
//         if (res?.accessTokenCartStreet) {
//           const newToken = res.accessTokenCartStreet;
//           setCookie("accessTokenCartStreet", newToken, 30);
//           localStorage.setItem("accessTokenCartStreet", newToken);
//           // ✅ با Bearer
//           originalRequest.headers["Authorization"] = `Bearer ${newToken}`;
//           return api(originalRequest);
//         }
//       } catch (refreshError) {
//         // refresh failed - پاک کردن توکن
//         localStorage.removeItem("accessTokenCartStreet");
//         setCookie("accessTokenCartStreet", "", -1);
//         setCookie("refreshToken", "", -1);
//         // ریدایرکت به لاگین
//         if (typeof window !== "undefined") {
//           window.location.href = '/login';
//         }
//         return Promise.reject(new Error('SESSION_EXPIRED'));
//       }
//     }

//     return Promise.reject(error?.response?.data || error.message);
//   }
// );

// export default api;

// // تابع refresh token
// const getNewTokens = async () => {
//   const refreshToken = getCookie("refreshToken");
//   if (!refreshToken) return {};

//   try {
//     const res = await axios.post(`${BASE_URL}/auth/refresh-token`, {
//       refresh_token: refreshToken,
//     }, {
//       timeout: 10000,
//       headers: {
//         "Content-Type": "application/json",
//       }
//     });
//     return res?.data || {};
//   } catch (error) {
//     console.error("Refresh token error:", error);
//     return {};
//   }
// };


// import axios from "axios";
// import { getCookie, setCookie } from "../../../lib/cookie.js";

// // دریافت تنظیمات بر اساس محیط
// export const getBaseUrl = () => {
//   // اولویت 1: متغیر محیطی VITE_BASE_URL (از فایل .env)
//   if (import.meta.env.VITE_BASE_URL) {
//     return import.meta.env.VITE_BASE_URL;
//   }

//   // اولویت 2: تشخیص خودکار بر اساس hostname
//   if (typeof window !== 'undefined') {
//     const hostname = window.location.hostname;

//     // محیط staging
//     if (hostname.includes('staging') || hostname.includes('test')) {
//       return '/api';
//     }

//     // محیط production
//     if (hostname.includes('sharjdev') || hostname.includes('sharjstreet')) {
//       return '/api';
//     }
//   }

//   // Fallback
//   return '/api';
// };

// // متغیرهای محیطی
// export const ENV = {
//   mode: import.meta.env.VITE_APP_ENV || import.meta.env.MODE || 'development',
//   isDevelopment: import.meta.env.VITE_APP_ENV === 'development' || import.meta.env.DEV,
//   isStaging: import.meta.env.VITE_APP_ENV === 'staging',
//   isProduction: import.meta.env.VITE_APP_ENV === 'production' || import.meta.env.PROD,
//   baseURL: getBaseUrl(),
//   apiTimeout: parseInt(import.meta.env.VITE_API_TIMEOUT || '15000'),
//   useProxy: import.meta.env.VITE_USE_PROXY === 'true',
// };
// const logger = {
//   log: (...args: any[]) => {
//     if (!ENV.isProduction) {
//       console.log(`[${ENV.mode}]`, ...args);
//     }
//   },
//   error: (...args: any[]) => {
//     if (!ENV.isProduction) {
//       console.error(`[${ENV.mode}]`, ...args);
//     }
//   },
//   warn: (...args: any[]) => {
//     if (!ENV.isProduction) {
//       console.warn(`[${ENV.mode}]`, ...args);
//     }
//   }
// };

// // لاگ کردن baseURL در شروع
// logger.log(`Base URL: ${ENV.baseURL}`);
// logger.log(`Environment: ${ENV.mode}`);

// // وضعیت اتصال اینترنت
// let isOnline = typeof navigator !== 'undefined' ? navigator.onLine : true;

// if (typeof window !== 'undefined') {
//   window.addEventListener('online', () => {
//     isOnline = true;
//     logger.log("Internet connection restored");
//   });

//   window.addEventListener('offline', () => {
//     isOnline = false;
//     logger.log("Internet connection lost");
//   });
// }

// // ایجاد نمونه axios
// const api = axios.create({
//   baseURL: ENV.baseURL,
//   timeout: ENV.apiTimeout,
//   headers: {
//     "Content-Type": "application/json",
//   },
//   withCredentials: true,
// });

// // مسیرهای عمومی (نیاز به احراز هویت ندارند)
// const publicRoutes = [
//   "User/SendOtp",
//   "User/ConfirmOtp",
//   "customerPanel/login/sendOtp",
//   "customerPanel/login/validateOTP",
//   "select-role",
//   "/select-role/login-oranization",
//   "/select-role/login-organization/forget-password",
//   "/EnterOtp"
// ];

// // مسیرهایی که توکن برمی‌گردانند
// const tokenReturningRoutes = [
//   "customerPanel/login/validateOTP",
//   "managerPanel/login/super_admin",
//   "customerPanel/legal/login/login"
// ];

// // اینترسپتور درخواست
// api.interceptors.request.use(
//   (config: any) => {
//     // بررسی اتصال اینترنت
//     if (!isOnline) {
//       logger.warn("No internet connection for request:", config.url);
//       return Promise.reject(new Error('NO_INTERNET_CONNECTION'));
//     }

//     // دریافت توکن
//     let accessTokenCartStreet = getCookie("accessTokenCartStreet");
//     console.log(accessTokenCartStreet)
//     if (!accessTokenCartStreet && typeof window !== "undefined") {
//       accessTokenCartStreet = localStorage.getItem("accessTokenCartStreet") || "";
//     }
//     console.log(accessTokenCartStreet)

//     // بررسی آیا مسیر عمومی است
//     const isPublic = publicRoutes.some((route) =>
//       config.url?.includes(route)
//     );
//     console.log(accessTokenCartStreet)

//     // اضافه کردن توکن به هدر (فقط برای مسیرهای غیر عمومی)
//     if (!isPublic && accessTokenCartStreet) {
//       console.log(accessTokenCartStreet)
//       config.headers["Authorization"] = `Bearer ${accessTokenCartStreet}`;
//     }
//     console.log(accessTokenCartStreet)


//     // لاگ درخواست (فقط در محیط غیر پروداکشن)
//     logger.log(`API Request: ${config.method?.toUpperCase()} ${config.url}`);

//     return config;
//   },
//   (error) => {
//     logger.error("Request interceptor error:", error);
//     return Promise.reject(error);
//   }
// );

// // اینترسپتور پاسخ
// api.interceptors.response.use(
//   (response) => {
//     const url = response.config?.url || "";
//     const isTokenRoute = tokenReturningRoutes.some((route) => url.includes(route));

//     // ذخیره توکن اگر مسیر برگرداندن توکن است
//     if (isTokenRoute) {
//       const authHeader = response.headers["authorization"]
//         || response.headers["Authorization"]
//         || null;

//       if (authHeader && typeof authHeader === "string") {
//         let token = authHeader;
//         if (token.startsWith("Bearer ")) {
//           token = token.substring(7);
//         }
//         if (token) {
//           setCookie("accessTokenCartStreet", token, 30);
//           if (typeof window !== "undefined") {
//             localStorage.setItem("accessTokenCartStreet", token);
//           }
//           logger.log("Token saved successfully from:", url);
//         }
//       }
//     }

//     // لاگ پاسخ موفق
//     logger.log(`API Response: ${response.status} ${url}`);

//     return response;
//   },
//   async (error) => {
//     const originalRequest = error.config;

//     // خطای عدم اتصال به اینترنت
//     if (error?.message === 'NO_INTERNET_CONNECTION') {
//       logger.warn("No internet connection");
//       return Promise.reject(new Error('NO_INTERNET_CONNECTION'));
//     }

//     // خطای تایم‌اوت
//     if (error?.code === 'ECONNABORTED' || error?.message?.includes('timeout')) {
//       logger.error("Request timeout:", originalRequest?.url);
//       return Promise.reject(new Error('درخواست زمان‌بر بود، لطفاً دوباره تلاش کنید'));
//     }

//     // خطای شبکه
//     if (error?.message === 'Network Error') {
//       logger.error("Network error:", originalRequest?.url);
//       return Promise.reject(new Error('مشکل در ارتباط با سرور، لطفاً دوباره تلاش کنید'));
//     }

//     // خطای 401 - تلاش برای دریافت توکن جدید
//     if (error?.response?.status === 401 && !originalRequest._retry) {
//       originalRequest._retry = true;
//       logger.log("Token expired, trying to refresh...");

//       try {
//         const res = await getNewTokens();
//         if (res?.accessTokenCartStreet) {
//           const newToken = res.accessTokenCartStreet;

//           // ذخیره توکن‌های جدید
//           setCookie("accessTokenCartStreet", newToken, 30);
//           setCookie("refreshToken", res.refreshToken, 360);

//           if (typeof window !== 'undefined') {
//             localStorage.setItem("accessTokenCartStreet", newToken);
//           }

//           // به‌روزرسانی هدر و تکرار درخواست
//           originalRequest.headers["Authorization"] = `Bearer ${newToken}`;
//           logger.log("Token refreshed, retrying request");
//           return api(originalRequest);
//         }
//       } catch (refreshError) {
//         logger.error("Refresh token failed:", refreshError);

//         // پاک کردن توکن‌های منقضی شده
//         if (typeof window !== 'undefined') {
//           localStorage.removeItem("accessTokenCartStreet");
//           setCookie("accessTokenCartStreet", "", -1);
//           setCookie("refreshToken", "", -1);
//         }

//         // ریدایرکت به لاگین
//         if (typeof window !== 'undefined') {
//           window.location.href = '/login';
//         }

//         return Promise.reject(new Error('SESSION_EXPIRED'));
//       }
//     }

//     // لاگ خطاهای دیگر
//     logger.error(`API Error: ${error?.response?.status || 'unknown'}`, error?.response?.data || error.message);

//     return Promise.reject(error?.response?.data || error.message);
//   }
// );

// export default api;

// // تابع دریافت توکن جدید
// const getNewTokens = async () => {
//   const refreshToken = getCookie("refreshToken");

//   if (!refreshToken) {
//     logger.warn("No refresh token found");
//     return {};
//   }

//   try {
//     const response = await axios.post(
//       `${ENV.baseURL}/auth/refresh-token`,
//       {
//         refresh_token: refreshToken,
//       },
//       {
//         timeout: 10000,
//         headers: {
//           "Content-Type": "application/json",
//         }
//       }
//     );

//     logger.log("New tokens received successfully");
//     return response?.data || {};
//   } catch (error) {
//     logger.error("Refresh token error:", error);
//     return {};
//   }
// };


// import axios from "axios";
// import { getCookie, setCookie } from "../../../lib/cookie.js";

// // دریافت تنظیمات بر اساس محیط
// // // متغیرهای محیطی
// export const ENV = {
//   mode: import.meta.env.VITE_APP_ENV || import.meta.env.MODE || "development",
//   isDevelopment:
//     import.meta.env.VITE_APP_ENV === "development" || import.meta.env.DEV,
//   isStaging: import.meta.env.VITE_APP_ENV === "staging",
//   isProduction:
//     import.meta.env.VITE_APP_ENV === "production" || import.meta.env.PROD,
//   baseURL: getBaseUrl(),
//   apiTimeout: parseInt(import.meta.env.VITE_API_TIMEOUT || "15000"),
//   useProxy: import.meta.env.VITE_USE_PROXY === "true",
// };

// // Logger
// const logger = {
//   log: (...args: any[]) => {
//     if (!ENV.isProduction) console.log(`[${ENV.mode}]`, ...args);
//   },
//   error: (...args: any[]) => {
//     if (!ENV.isProduction) console.error(`[${ENV.mode}]`, ...args);
//   },
//   warn: (...args: any[]) => {
//     if (!ENV.isProduction) console.warn(`[${ENV.mode}]`, ...args);
//   },
// };

// logger.log(`Base URL: ${ENV.baseURL}`);
// logger.log(`Environment: ${ENV.mode}`);

// // وضعیت اتصال اینترنت
// let isOnline = typeof navigator !== "undefined" ? navigator.onLine : true;

// if (typeof window !== "undefined") {
//   window.addEventListener("online", () => {
//     isOnline = true;
//     logger.log("Internet connection restored");
//   });

//   window.addEventListener("offline", () => {
//     isOnline = false;
//     logger.log("Internet connection lost");
//   });
// }

// // ایجاد نمونه axios
// const api = axios.create({
//   baseURL: ENV.baseURL,
//   timeout: ENV.apiTimeout,
//   headers: {
//     "Content-Type": "application/json",
//   },
//   withCredentials: true,
// });

// // مسیرهای عمومی (نیاز به احراز هویت ندارند)
// const publicRoutes = [
//   "User/SendOtp",
//   "User/ConfirmOtp",
//   "customerPanel/login/sendOtp",
//   "customerPanel/login/validateOTP",
//   "select-role",
//   "/select-role/login-oranization",
//   "/select-role/login-organization/forget-password",
//   "/EnterOtp",
// ];

// // مسیرهایی که توکن برمی‌گردانند
// const tokenReturningRoutes = [
//   "customerPanel/login/validateOTP",
//   "managerPanel/login/super_admin",
//   "customerPanel/legal/login/login",
// ];

// // ⭐ ساخت یک Error استاندارد از داده‌ی بک‌اند
// const buildApiError = (
//   data: any,
//   fallbackMessage?: string,
//   status?: number
// ): Error => {
//   const apiError: any = new Error(
//     data?.message || fallbackMessage || "خطایی رخ داد"
//   );
//   apiError.response = {
//     data,
//     status: status ?? data?.code ?? null,
//   };
//   apiError.isApiError = true;
//   apiError.originalData = data;
//   return apiError;
// };

// // اینترسپتور درخواست
// api.interceptors.request.use(
//   (config: any) => {
//     // بررسی اتصال اینترنت
//     if (!isOnline) {
//       logger.warn("No internet connection for request:", config.url);
//       return Promise.reject(new Error("NO_INTERNET_CONNECTION"));
//     }

//     // دریافت توکن
//     let accessTokenCartStreet = getCookie("accessTokenCartStreet");
//     if (!accessTokenCartStreet && typeof window !== "undefined") {
//       accessTokenCartStreet =
//         localStorage.getItem("accessTokenCartStreet") || "";
//     }

//     // بررسی آیا مسیر عمومی است
//     const isPublic = publicRoutes.some((route) =>
//       config.url?.includes(route)
//     );

//     // اضافه کردن توکن به هدر (فقط برای مسیرهای غیر عمومی)
//     if (!isPublic && accessTokenCartStreet) {
//       config.headers["Authorization"] = `Bearer ${accessTokenCartStreet}`;
//     }

//     logger.log(`API Request: ${config.method?.toUpperCase()} ${config.url}`);

//     return config;
//   },
//   (error) => {
//     logger.error("Request interceptor error:", error);
//     return Promise.reject(error);
//   }
// );

// // اینترسپتور پاسخ
// api.interceptors.response.use(
//   (response) => {
//     const url = response.config?.url || "";
//     const isTokenRoute = tokenReturningRoutes.some((route) =>
//       url.includes(route)
//     );

//     // ذخیره توکن اگر مسیر برگرداندن توکن است
//     if (isTokenRoute) {
//       const authHeader =
//         response.headers["authorization"] ||
//         response.headers["Authorization"] ||
//         null;

//       if (authHeader && typeof authHeader === "string") {
//         let token = authHeader;
//         if (token.startsWith("Bearer ")) {
//           token = token.substring(7);
//         }
//         if (token) {
//           setCookie("accessTokenCartStreet", token, 30);
//           if (typeof window !== "undefined") {
//             localStorage.setItem("accessTokenCartStreet", token);
//           }
//           logger.log("Token saved successfully from:", url);
//         }
//       }
//     }

//     logger.log(`API Response: ${response.status} ${url}`);

//     // ⭐⭐⭐ چک hasError از بدنه ریسپانس (حتی وقتی status=200 باشه)
//     const data: any = response.data;
//     if (data && typeof data === "object" && data.hasError === true) {
//       console.log("🚨 [1] Interceptor detected hasError:", {
//         code: data.code,
//         message: data.message,
//         url,
//       });
//       return Promise.reject(
//         buildApiError(data, "خطایی رخ داد", response.status)
//       );
//     }

//     return response;
//   },
//   async (error) => {
//     const originalRequest = error.config;

//     // خطای عدم اتصال به اینترنت
//     if (error?.message === "NO_INTERNET_CONNECTION") {
//       logger.warn("No internet connection");
//       return Promise.reject(
//         buildApiError(null, "اتصال اینترنت خود را بررسی کنید")
//       );
//     }

//     // خطای تایم‌اوت
//     if (
//       error?.code === "ECONNABORTED" ||
//       error?.message?.includes("timeout")
//     ) {
//       logger.error("Request timeout:", originalRequest?.url);
//       return Promise.reject(
//         buildApiError(null, "درخواست زمان‌بر بود، لطفاً دوباره تلاش کنید")
//       );
//     }

//     // خطای شبکه
//     if (error?.message === "Network Error") {
//       logger.error("Network error:", originalRequest?.url);
//       return Promise.reject(
//         buildApiError(
//           null,
//           "مشکل در ارتباط با سرور، لطفاً دوباره تلاش کنید"
//         )
//       );
//     }

//     // خطای 401 - تلاش برای دریافت توکن جدید
//     if (error?.response?.status === 401 && !originalRequest._retry) {
//       originalRequest._retry = true;
//       logger.log("Token expired, trying to refresh...");

//       try {
//         const res = await getNewTokens();
//         if (res?.accessTokenCartStreet) {
//           const newToken = res.accessTokenCartStreet;

//           setCookie("accessTokenCartStreet", newToken, 30);
//           setCookie("refreshToken", res.refreshToken, 360);

//           if (typeof window !== "undefined") {
//             localStorage.setItem("accessTokenCartStreet", newToken);
//           }

//           originalRequest.headers["Authorization"] = `Bearer ${newToken}`;
//           logger.log("Token refreshed, retrying request");
//           return api(originalRequest);
//         }
//       } catch (refreshError) {
//         logger.error("Refresh token failed:", refreshError);

//         if (typeof window !== "undefined") {
//           localStorage.removeItem("accessTokenCartStreet");
//           setCookie("accessTokenCartStreet", "", -1);
//           setCookie("refreshToken", "", -1);
//           window.location.href = "/login";
//         }

//         return Promise.reject(
//           buildApiError(
//             null,
//             "نشست شما منقضی شده است. لطفا دوباره وارد شوید"
//           )
//         );
//       }
//     }

//     // ⭐ خطای HTTP معمولی (400, 403, 404, 500, ...)
//     const errorData = error?.response?.data;

//     console.log("🚨 [1-http] HTTP Error detected:", {
//       status: error?.response?.status,
//       url: originalRequest?.url,
//       data: errorData,
//     });

//     logger.error(
//       `API Error: ${error?.response?.status || "unknown"}`,
//       errorData || error.message
//     );

//     return Promise.reject(
//       buildApiError(
//         errorData,
//         error?.message || "خطایی رخ داد",
//         error?.response?.status
//       )
//     );
//   }
// );

// export default api;

// // تابع دریافت توکن جدید
// const getNewTokens = async () => {
//   const refreshToken = getCookie("refreshToken");

//   if (!refreshToken) {
//     logger.warn("No refresh token found");
//     return {};
//   }

//   try {
//     const response = await axios.post(
//       `${ENV.baseURL}/auth/refresh-token`,
//       {
//         refresh_token: refreshToken,
//       },
//       {
//         timeout: 10000,
//         headers: {
//           "Content-Type": "application/json",
//         },
//       }
//     );

//     logger.log("New tokens received successfully");
//     return response?.data || {};
//   } catch (error) {
//     logger.error("Refresh token error:", error);
//     return {};
//   }
// };
// src/core/config/api/index.ts
// import axios from "axios";
// import { getCookie, setCookie } from "../../../lib/cookie.js";

// // ===== تنظیمات محیط =====
// export const getBaseUrl = () => {
//   if (import.meta.env.VITE_BASE_URL) {
//     return import.meta.env.VITE_BASE_URL;
//   }

//   if (typeof window !== "undefined") {
//     const hostname = window.location.hostname;

//     if (hostname.includes("staging") || hostname.includes("test")) {
//       return "/api";
//     }

//     if (hostname.includes("sharjdev") || hostname.includes("sharjstreet")) {
//       return "/api";
//     }
//   }

//   return "/api";
// };

// export const ENV = {
//   mode: import.meta.env.VITE_APP_ENV || import.meta.env.MODE || "development",
//   isDevelopment:
//     import.meta.env.VITE_APP_ENV === "development" || import.meta.env.DEV,
//   isStaging: import.meta.env.VITE_APP_ENV === "staging",
//   isProduction:
//     import.meta.env.VITE_APP_ENV === "production" || import.meta.env.PROD,
//   baseURL: getBaseUrl(),
//   apiTimeout: parseInt(import.meta.env.VITE_API_TIMEOUT || "15000"),
//   useProxy: import.meta.env.VITE_USE_PROXY === "true",
// };

// // ===== Logger =====
// const logger = {
//   log: (...args: any[]) => {
//     if (!ENV.isProduction) console.log(`[${ENV.mode}]`, ...args);
//   },
//   error: (...args: any[]) => {
//     if (!ENV.isProduction) console.error(`[${ENV.mode}]`, ...args);
//   },
//   warn: (...args: any[]) => {
//     if (!ENV.isProduction) console.warn(`[${ENV.mode}]`, ...args);
//   },
// };

// logger.log(`Base URL: ${ENV.baseURL}`);
// logger.log(`Environment: ${ENV.mode}`);

// // ===== وضعیت اتصال =====
// let isOnline = typeof navigator !== "undefined" ? navigator.onLine : true;

// if (typeof window !== "undefined") {
//   window.addEventListener("online", () => {
//     isOnline = true;
//     logger.log("Internet connection restored");
//   });

//   window.addEventListener("offline", () => {
//     isOnline = false;
//     logger.log("Internet connection lost");
//   });
// }

// // ===== نمونه axios =====
// const api = axios.create({
//   baseURL: ENV.baseURL,
//   timeout: ENV.apiTimeout,
//   headers: { "Content-Type": "application/json" },
//   withCredentials: true,
// });

// // ===== مسیرها =====
// const publicRoutes = [
//   "User/SendOtp",
//   "User/ConfirmOtp",
//   "customerPanel/login/sendOtp",
//   "customerPanel/login/validateOTP",
//   "/login-oranization",
//   "/login-organization/forget-password",
//   "/EnterOtp",
// ];

// const tokenReturningRoutes = [
//   "customerPanel/login/validateOTP",
//   "managerPanel/login/super_admin",
//   "customerPanel/legal/login/login",
// ];

// // ===== ابزارهای داخلی =====
// const buildApiError = (
//   data: any,
//   fallbackMessage?: string,
//   status?: number
// ): Error => {
//   const apiError: any = new Error(
//     data?.message || fallbackMessage || "خطایی رخ داد"
//   );
//   apiError.response = {
//     data: data ?? null,
//     status: status ?? data?.code ?? null,
//   };
//   apiError.isApiError = true;
//   apiError.originalData = data ?? null;
//   apiError.code = data?.code ?? null;
//   return apiError;
// };

// const isHasError = (data: any): boolean => {
//   if (!data || typeof data !== "object") return false;
//   const v = data.hasError;
//   return v === true || v === 1 || v === "true" || v === "1";
// };

// const isPublicRoute = (url?: string) => {
//   if (!url) return false;
//   return publicRoutes.some((route) => url.includes(route));
// };

// const isTokenRoute = (url?: string) => {
//   if (!url) return false;
//   return tokenReturningRoutes.some((route) => url.includes(route));
// };

// const extractTokenFromHeaders = (headers: any): string | null => {
//   const authHeader =
//     headers?.["authorization"] || headers?.["Authorization"] || null;
//   if (!authHeader || typeof authHeader !== "string") return null;
//   let token = authHeader;
//   if (token.startsWith("Bearer ")) token = token.substring(7);
//   return token || null;
// };

// const persistAccessToken = (token: string) => {
//   setCookie("accessTokenCartStreet", token, 30);
//   if (typeof window !== "undefined") {
//     localStorage.setItem("accessTokenCartStreet", token);
//   }
// };

// const clearTokens = () => {
//   setCookie("accessTokenCartStreet", "", -1);
//   setCookie("refreshToken", "", -1);
//   if (typeof window !== "undefined") {
//     localStorage.removeItem("accessTokenCartStreet");
//     localStorage.removeItem("refreshToken");
//   }
// };

// const redirectToLogin = () => {
//   if (typeof window !== "undefined") {
//     window.location.replace("/login");
//   }
// };

// // ===== دریافت توکن جدید =====
// const getNewTokens = async () => {
//   let refreshToken = getCookie("refreshToken");
//   if (!refreshToken && typeof window !== "undefined") {
//     refreshToken = localStorage.getItem("refreshToken") || "";
//   }

//   if (!refreshToken) {
//     logger.warn("No refresh token found");
//     return {};
//   }

//   try {
//     const response = await axios.post(
//       `${ENV.baseURL}/auth/refresh-token`,
//       { refresh_token: refreshToken },
//       {
//         timeout: 10000,
//         headers: { "Content-Type": "application/json" },
//         withCredentials: true,
//       }
//     );

//     logger.log("New tokens received successfully");

//     const data = response?.data || {};
//     const authHeader = extractTokenFromHeaders(response.headers);
//     const accessTokenCartStreet =
//       data?.accessTokenCartStreet || data?.accessToken || authHeader || null;

//     return {
//       accessTokenCartStreet,
//       refreshToken: data?.refreshToken || null,
//     };
//   } catch (error) {
//     logger.error("Refresh token error:", error);
//     return {};
//   }
// };

// // ===== اینترسپتور درخواست =====
// api.interceptors.request.use(
//   (config: any) => {
//     if (!isOnline) {
//       logger.warn("No internet connection for request:", config.url);
//       return Promise.reject(new Error("NO_INTERNET_CONNECTION"));
//     }

//     let accessTokenCartStreet = getCookie("accessTokenCartStreet");
//     if (!accessTokenCartStreet && typeof window !== "undefined") {
//       accessTokenCartStreet =
//         localStorage.getItem("accessTokenCartStreet") || "";
//     }

//     const isPublic = isPublicRoute(config.url);

//     if (!isPublic && accessTokenCartStreet) {
//       config.headers["Authorization"] = `Bearer ${accessTokenCartStreet}`;
//     }

//     logger.log(`API Request: ${config.method?.toUpperCase()} ${config.url}`);

//     return config;
//   },
//   (error) => {
//     logger.error("Request interceptor error:", error);
//     return Promise.reject(error);
//   }
// );

// // ===== اینترسپتور پاسخ =====
// api.interceptors.response.use(
//   (response) => {
//     const url = response.config?.url || "";

//     if (isTokenRoute(url)) {
//       const token = extractTokenFromHeaders(response.headers);
//       if (token) {
//         persistAccessToken(token);
//         logger.log("Token saved successfully from:", url);
//       }
//     }

//     logger.log(`API Response: ${response.status} ${url}`);

//     const data: any = response.data;
//     if (isHasError(data)) {
//       logger.error("Interceptor detected hasError:", {
//         code: data.code,
//         message: data.message,
//         url,
//       });
//       return Promise.reject(
//         buildApiError(data, "خطایی رخ داد", response.status)
//       );
//     }

//     return response;
//   },
//   async (error) => {
//     const originalRequest = error?.config;

//     if (error?.message === "NO_INTERNET_CONNECTION") {
//       logger.warn("No internet connection");
//       return Promise.reject(
//         buildApiError(null, "اتصال اینترنت خود را بررسی کنید")
//       );
//     }

//     if (
//       error?.code === "ECONNABORTED" ||
//       error?.message?.includes("timeout")
//     ) {
//       logger.error("Request timeout:", originalRequest?.url);
//       return Promise.reject(
//         buildApiError(null, "درخواست زمان‌بر بود، لطفاً دوباره تلاش کنید")
//       );
//     }

//     if (error?.message === "Network Error") {
//       logger.error("Network error:", originalRequest?.url);
//       return Promise.reject(
//         buildApiError(null, "مشکل در ارتباط با سرور، لطفاً دوباره تلاش کنید")
//       );
//     }

//     if (
//       error?.response?.status === 401 &&
//       originalRequest &&
//       !originalRequest._retry
//     ) {
//       originalRequest._retry = true;
//       logger.log("Token expired, trying to refresh...");

//       try {
//         const res = await getNewTokens();
//         const newToken = res?.accessTokenCartStreet;

//         if (newToken) {
//           persistAccessToken(newToken);

//           if (res?.refreshToken) {
//             setCookie("refreshToken", res.refreshToken, 360);
//             if (typeof window !== "undefined") {
//               localStorage.setItem("refreshToken", res.refreshToken);
//             }
//           }

//           originalRequest.headers = originalRequest.headers || {};
//           originalRequest.headers["Authorization"] = `Bearer ${newToken}`;
//           logger.log("Token refreshed, retrying request");
//           return api(originalRequest);
//         }

//         throw new Error("NO_NEW_TOKEN");
//       } catch (refreshError) {
//         logger.error("Refresh token failed:", refreshError);
//         return Promise.reject(
//           buildApiError(
//             null,
//             "نشست شما منقضی شده است. لطفا دوباره وارد شوید"
//           )
//         );
//       }
//     }

//     const errorData = error?.response?.data;

//     logger.error(
//       `API Error: ${error?.response?.status || "unknown"}`,
//       errorData || error.message
//     );

//     if (isHasError(errorData)) {
//       return Promise.reject(
//         buildApiError(errorData, "خطایی رخ داد", error?.response?.status)
//       );
//     }

//     return Promise.reject(
//       buildApiError(
//         errorData,
//         error?.message || "خطایی رخ داد",
//         error?.response?.status
//       )
//     );
//   }
// );

// export default api;

// import axios from "axios";
// import { getCookie, setCookie } from "../../../lib/cookie.js";

// // ===== تنظیمات محیط =====
// export const getBaseUrl = () => {
//   if (import.meta.env.VITE_BASE_URL) {
//     return import.meta.env.VITE_BASE_URL;
//   }

//   if (typeof window !== "undefined") {
//     const hostname = window.location.hostname;

//     if (hostname.includes("staging") || hostname.includes("test")) {
//       return "/api";
//     }

//     if (hostname.includes("sharjdev") || hostname.includes("sharjstreet")) {
//       return "/api";
//     }
//   }

//   return "/api";
// };

// export const ENV = {
//   mode: import.meta.env.VITE_APP_ENV || import.meta.env.MODE || "development",
//   isDevelopment:
//     import.meta.env.VITE_APP_ENV === "development" || import.meta.env.DEV,
//   isStaging: import.meta.env.VITE_APP_ENV === "staging",
//   isProduction:
//     import.meta.env.VITE_APP_ENV === "production" || import.meta.env.PROD,
//   baseURL: getBaseUrl(),
//   apiTimeout: parseInt(import.meta.env.VITE_API_TIMEOUT || String(30 * 60 * 1000)),
//   useProxy: import.meta.env.VITE_USE_PROXY === "true",
// };

// // ===== Logger =====
// const logger = {
//   log: (...args: any[]) => {
//     if (!ENV.isProduction) console.log(`[${ENV.mode}]`, ...args);
//   },
//   error: (...args: any[]) => {
//     if (!ENV.isProduction) console.error(`[${ENV.mode}]`, ...args);
//   },
//   warn: (...args: any[]) => {
//     if (!ENV.isProduction) console.warn(`[${ENV.mode}]`, ...args);
//   },
// };

// logger.log(`Base URL: ${ENV.baseURL}`);
// logger.log(`Environment: ${ENV.mode}`);

// // ===== وضعیت اتصال =====
// let isOnline = typeof navigator !== "undefined" ? navigator.onLine : true;

// if (typeof window !== "undefined") {
//   window.addEventListener("online", () => {
//     isOnline = true;
//     logger.log("Internet connection restored");
//   });

//   window.addEventListener("offline", () => {
//     isOnline = false;
//     logger.log("Internet connection lost");
//   });
// }

// // ===== نمونه axios =====
// const api = axios.create({
//   baseURL: ENV.baseURL,
//   timeout: ENV.apiTimeout,
//   headers: { "Content-Type": "application/json" },
//   withCredentials: true,
// });

// // ===== مسیرها =====
// const publicRoutes = [
//   "User/SendOtp",
//   "User/ConfirmOtp",
//   "customerPanel/login/sendOtp",
//   "customerPanel/login/validateOTP",
//   "/login-oranization",
//   "/login-organization/forget-password",
//   "/EnterOtp",
// ];

// const tokenReturningRoutes = [
//   "customerPanel/login/validateOTP",
//   "managerPanel/login/super_admin",
//   "customerPanel/legal/login/login",
// ];

// // ===== ابزارهای داخلی =====
// const buildApiError = (
//   data: any,
//   fallbackMessage?: string,
//   status?: number
// ): Error => {
//   const apiError: any = new Error(
//     data?.message || fallbackMessage || "خطایی رخ داد"
//   );
//   apiError.response = {
//     data: data ?? null,
//     status: status ?? data?.code ?? null,
//   };
//   apiError.isApiError = true;
//   apiError.originalData = data ?? null;
//   apiError.code = data?.code ?? null;
//   return apiError;
// };

// const isHasError = (data: any): boolean => {
//   if (!data || typeof data !== "object") return false;
//   const v = data.hasError;
//   return v === true || v === 1 || v === "true" || v === "1";
// };

// // ✅ helper جدید — تشخیص Blob
// const isBlob = (v: any): v is Blob =>
//   typeof Blob !== "undefined" && v instanceof Blob;

// // ✅ helper جدید — خواندن JSON داخل Blob
// const parseBlobError = async (blob: Blob): Promise<any | null> => {
//   try {
//     const text = await blob.text();
//     return JSON.parse(text);
//   } catch {
//     return null;
//   }
// };

// const isPublicRoute = (url?: string) => {
//   if (!url) return false;
//   return publicRoutes.some((route) => url.includes(route));
// };

// const isTokenRoute = (url?: string) => {
//   if (!url) return false;
//   return tokenReturningRoutes.some((route) => url.includes(route));
// };

// const extractTokenFromHeaders = (headers: any): string | null => {
//   const authHeader =
//     headers?.["authorization"] || headers?.["Authorization"] || null;
//   if (!authHeader || typeof authHeader !== "string") return null;
//   let token = authHeader;
//   if (token.startsWith("Bearer ")) token = token.substring(7);
//   return token || null;
// };

// const persistAccessToken = (token: string) => {
//   setCookie("accessTokenCartStreet", token, 30);
//   if (typeof window !== "undefined") {
//     localStorage.setItem("accessTokenCartStreet", token);
//   }
// };

// const clearTokens = () => {
//   setCookie("accessTokenCartStreet", "", -1);
//   setCookie("refreshToken", "", -1);
//   if (typeof window !== "undefined") {
//     localStorage.removeItem("accessTokenCartStreet");
//     localStorage.removeItem("refreshToken");
//   }
// };

// const redirectToLogin = () => {
//   if (typeof window !== "undefined") {
//     window.location.replace("/login");
//   }
// };

// // ===== دریافت توکن جدید =====
// const getNewTokens = async () => {
//   let refreshToken = getCookie("refreshToken");
//   if (!refreshToken && typeof window !== "undefined") {
//     refreshToken = localStorage.getItem("refreshToken") || "";
//   }

//   if (!refreshToken) {
//     logger.warn("No refresh token found");
//     return {};
//   }

//   try {
//     const response = await axios.post(
//       `${ENV.baseURL}/auth/refresh-token`,
//       { refresh_token: refreshToken },
//       {
//         timeout: 10000000,
//         headers: { "Content-Type": "application/json" },
//         withCredentials: true,
//       }
//     );

//     logger.log("New tokens received successfully");

//     const data = response?.data || {};
//     const authHeader = extractTokenFromHeaders(response.headers);
//     const accessTokenCartStreet =
//       data?.accessTokenCartStreet || data?.accessToken || authHeader || null;

//     return {
//       accessTokenCartStreet,
//       refreshToken: data?.refreshToken || null,
//     };
//   } catch (error) {
//     logger.error("Refresh token error:", error);
//     return {};
//   }
// };

// // ===== اینترسپتور درخواست =====
// api.interceptors.request.use(
//   (config: any) => {
//     if (!isOnline) {
//       logger.warn("No internet connection for request:", config.url);
//       return Promise.reject(new Error("NO_INTERNET_CONNECTION"));
//     }

//     let accessTokenCartStreet = getCookie("accessTokenCartStreet");
//     if (!accessTokenCartStreet && typeof window !== "undefined") {
//       accessTokenCartStreet =
//         localStorage.getItem("accessTokenCartStreet") || "";
//     }

//     const isPublic = isPublicRoute(config.url);

//     if (!isPublic && accessTokenCartStreet) {
//       config.headers["Authorization"] = `Bearer ${accessTokenCartStreet}`;
//     }

//     logger.log(`API Request: ${config.method?.toUpperCase()} ${config.url}`);

//     return config;
//   },
//   (error) => {
//     logger.error("Request interceptor error:", error);
//     return Promise.reject(error);
//   }
// );

// // ===== اینترسپتور پاسخ =====
// api.interceptors.response.use(
//   (response) => {
//     const url = response.config?.url || "";

//     if (isTokenRoute(url)) {
//       const token = extractTokenFromHeaders(response.headers);
//       if (token) {
//         persistAccessToken(token);
//         logger.log("Token saved successfully from:", url);
//       }
//     }

//     logger.log(`API Response: ${response.status} ${url}`);

//     const data: any = response.data;
//     if (isHasError(data)) {
//       logger.error("Interceptor detected hasError:", {
//         code: data.code,
//         message: data.message,
//         url,
//       });
//       return Promise.reject(
//         buildApiError(data, "خطایی رخ داد", response.status)
//       );
//     }

//     return response;
//   },
//   async (error) => {
//     const originalRequest = error?.config;

//     if (error?.message === "NO_INTERNET_CONNECTION") {
//       logger.warn("No internet connection");
//       return Promise.reject(
//         buildApiError(null, "اتصال اینترنت خود را بررسی کنید")
//       );
//     }

//     if (
//       error?.code === "ECONNABORTED" ||
//       error?.message?.includes("timeout")
//     ) {
//       logger.error("Request timeout:", originalRequest?.url);
//       return Promise.reject(
//         buildApiError(null, "درخواست زمان‌بر بود، لطفاً دوباره تلاش کنید")
//       );
//     }

//     if (error?.message === "Network Error") {
//       logger.error("Network error:", originalRequest?.url);
//       return Promise.reject(
//         buildApiError(null, "مشکل در ارتباط با سرور، لطفاً دوباره تلاش کنید")
//       );
//     }

//     if (
//       error?.response?.status === 401 &&
//       originalRequest &&
//       !originalRequest._retry
//     ) {
//       originalRequest._retry = true;
//       logger.log("Token expired, trying to refresh...");

//       try {
//         const res = await getNewTokens();
//         const newToken = res?.accessTokenCartStreet;

//         if (newToken) {
//           persistAccessToken(newToken);

//           if (res?.refreshToken) {
//             setCookie("refreshToken", res.refreshToken, 360);
//             if (typeof window !== "undefined") {
//               localStorage.setItem("refreshToken", res.refreshToken);
//             }
//           }

//           originalRequest.headers = originalRequest.headers || {};
//           originalRequest.headers["Authorization"] = `Bearer ${newToken}`;
//           logger.log("Token refreshed, retrying request");
//           return api(originalRequest);
//         }

//         throw new Error("NO_NEW_TOKEN");
//       } catch (refreshError) {
//         logger.error("Refresh token failed:", refreshError);
//         return Promise.reject(
//           buildApiError(
//             null,
//             "نشست شما منقضی شده است. لطفا دوباره وارد شوید"
//           )
//         );
//       }
//     }

//     // ============================================
//     // ✅ تغییر اصلی: تشخیص Blob و استخراج JSON
//     // ============================================
//     let errorData = error?.response?.data;

//     if (isBlob(errorData)) {
//       const parsed = await parseBlobError(errorData);
//       errorData = parsed ?? null;
//     }

//     logger.error(
//       `API Error: ${error?.response?.status || "unknown"}`,
//       errorData || error.message
//     );

//     if (isHasError(errorData)) {
//       return Promise.reject(
//         buildApiError(errorData, "خطایی رخ داد", error?.response?.status)
//       );
//     }

//     return Promise.reject(
//       buildApiError(
//         errorData,
//         error?.message || "خطایی رخ داد",
//         error?.response?.status
//       )
//     );
//   }
// );

// export default api;

// import axios from "axios";
// import { getCookie, setCookie } from "../../../lib/cookie.js";

// // ===== تنظیمات محیط =====
// export const getBaseUrl = () => {
//   if (import.meta.env.VITE_BASE_URL) {
//     return import.meta.env.VITE_BASE_URL;
//   }

//   if (typeof window !== "undefined") {
//     const hostname = window.location.hostname;

//     if (hostname.includes("staging") || hostname.includes("test")) {
//       return "/api";
//     }

//     if (hostname.includes("sharjdev") || hostname.includes("sharjstreet")) {
//       return "/api";
//     }
//   }

//   return "/api";
// };

// // ✅ ۱۰ دقیقه = 600,000 ms
// const TEN_MINUTES = 10 * 60 * 1000;

// export const ENV = {
//   mode: import.meta.env.VITE_APP_ENV || import.meta.env.MODE || "development",
//   isDevelopment:
//     import.meta.env.VITE_APP_ENV === "development" || import.meta.env.DEV,
//   isStaging: import.meta.env.VITE_APP_ENV === "staging",
//   isProduction:
//     import.meta.env.VITE_APP_ENV === "production" || import.meta.env.PROD,
//   baseURL: getBaseUrl(),
//   apiTimeout: parseInt(
//     import.meta.env.VITE_API_TIMEOUT || String(TEN_MINUTES)
//   ),
//   useProxy: import.meta.env.VITE_USE_PROXY === "true",
// };

// // ===== Logger =====
// const logger = {
//   log: (...args: any[]) => {
//     if (!ENV.isProduction) console.log(`[${ENV.mode}]`, ...args);
//   },
//   error: (...args: any[]) => {
//     if (!ENV.isProduction) console.error(`[${ENV.mode}]`, ...args);
//   },
//   warn: (...args: any[]) => {
//     if (!ENV.isProduction) console.warn(`[${ENV.mode}]`, ...args);
//   },
// };

// logger.log(`Base URL: ${ENV.baseURL}`);
// logger.log(`Environment: ${ENV.mode}`);
// logger.log(`API Timeout: ${ENV.apiTimeout} ms`);

// // ===== وضعیت اتصال =====
// let isOnline = typeof navigator !== "undefined" ? navigator.onLine : true;

// if (typeof window !== "undefined") {
//   window.addEventListener("online", () => {
//     isOnline = true;
//     logger.log("Internet connection restored");
//   });

//   window.addEventListener("offline", () => {
//     isOnline = false;
//     logger.log("Internet connection lost");
//   });
// }

// // ===== نمونه axios =====
// const api = axios.create({
//   baseURL: ENV.baseURL,
//   timeout: ENV.apiTimeout,
//   headers: { "Content-Type": "application/json" },
//   withCredentials: true,
// });

// // ===== مسیرها =====
// const publicRoutes = [
//   "User/SendOtp",
//   "User/ConfirmOtp",
//   "customerPanel/login/sendOtp",
//   "customerPanel/login/validateOTP",
//   "/login-oranization",
//   "/login-organization/forget-password",
//   "/EnterOtp",
// ];

// const tokenReturningRoutes = [
//   "customerPanel/login/validateOTP",
//   "managerPanel/login/super_admin",
//   "customerPanel/legal/login/login",
// ];

// // ===== ابزارهای داخلی =====
// const buildApiError = (
//   data: any,
//   fallbackMessage?: string,
//   status?: number
// ): Error => {
//   const apiError: any = new Error(
//     data?.message || fallbackMessage || "خطایی رخ داد"
//   );
//   apiError.response = {
//     data: data ?? null,
//     status: status ?? data?.code ?? null,
//   };
//   apiError.isApiError = true;
//   apiError.originalData = data ?? null;
//   apiError.code = data?.code ?? null;
//   return apiError;
// };

// const isHasError = (data: any): boolean => {
//   if (!data || typeof data !== "object") return false;
//   const v = data.hasError;
//   return v === true || v === 1 || v === "true" || v === "1";
// };

// // ✅ helper — تشخیص Blob
// const isBlob = (v: any): v is Blob =>
//   typeof Blob !== "undefined" && v instanceof Blob;

// // ✅ helper — خواندن JSON داخل Blob
// const parseBlobError = async (blob: Blob): Promise<any | null> => {
//   try {
//     const text = await blob.text();
//     return JSON.parse(text);
//   } catch {
//     return null;
//   }
// };

// const isPublicRoute = (url?: string) => {
//   if (!url) return false;
//   return publicRoutes.some((route) => url.includes(route));
// };

// const isTokenRoute = (url?: string) => {
//   if (!url) return false;
//   return tokenReturningRoutes.some((route) => url.includes(route));
// };

// const extractTokenFromHeaders = (headers: any): string | null => {
//   const authHeader =
//     headers?.["authorization"] || headers?.["Authorization"] || null;
//   if (!authHeader || typeof authHeader !== "string") return null;
//   let token = authHeader;
//   if (token.startsWith("Bearer ")) token = token.substring(7);
//   return token || null;
// };

// const persistAccessToken = (token: string) => {
//   setCookie("accessTokenCartStreet", token, 30);
//   if (typeof window !== "undefined") {
//     localStorage.setItem("accessTokenCartStreet", token);
//   }
// };

// const clearTokens = () => {
//   setCookie("accessTokenCartStreet", "", -1);
//   setCookie("refreshToken", "", -1);
//   if (typeof window !== "undefined") {
//     localStorage.removeItem("accessTokenCartStreet");
//     localStorage.removeItem("refreshToken");
//   }
// };

// const redirectToLogin = () => {
//   if (typeof window !== "undefined") {
//     window.location.replace("/login");
//   }
// };

// // ===== دریافت توکن جدید =====
// const getNewTokens = async () => {
//   let refreshToken = getCookie("refreshToken");
//   if (!refreshToken && typeof window !== "undefined") {
//     refreshToken = localStorage.getItem("refreshToken") || "";
//   }

//   if (!refreshToken) {
//     logger.warn("No refresh token found");
//     return {};
//   }

//   try {
//     const response = await axios.post(
//       `${ENV.baseURL}/auth/refresh-token`,
//       { refresh_token: refreshToken },
//       {
//         timeout: TEN_MINUTES, // ✅ ۱۰ دقیقه
//         headers: { "Content-Type": "application/json" },
//         withCredentials: true,
//       }
//     );

//     logger.log("New tokens received successfully");

//     const data = response?.data || {};
//     const authHeader = extractTokenFromHeaders(response.headers);
//     const accessTokenCartStreet =
//       data?.accessTokenCartStreet || data?.accessToken || authHeader || null;

//     return {
//       accessTokenCartStreet,
//       refreshToken: data?.refreshToken || null,
//     };
//   } catch (error) {
//     logger.error("Refresh token error:", error);
//     return {};
//   }
// };

// // ===== اینترسپتور درخواست =====
// api.interceptors.request.use(
//   (config: any) => {
//     if (!isOnline) {
//       logger.warn("No internet connection for request:", config.url);
//       return Promise.reject(new Error("NO_INTERNET_CONNECTION"));
//     }

//     let accessTokenCartStreet = getCookie("accessTokenCartStreet");
//     if (!accessTokenCartStreet && typeof window !== "undefined") {
//       accessTokenCartStreet =
//         localStorage.getItem("accessTokenCartStreet") || "";
//     }

//     const isPublic = isPublicRoute(config.url);

//     if (!isPublic && accessTokenCartStreet) {
//       config.headers["Authorization"] = `Bearer ${accessTokenCartStreet}`;
//     }

//     logger.log(`API Request: ${config.method?.toUpperCase()} ${config.url}`);

//     return config;
//   },
//   (error) => {
//     logger.error("Request interceptor error:", error);
//     return Promise.reject(error);
//   }
// );

// // ===== اینترسپتور پاسخ =====
// api.interceptors.response.use(
//   (response) => {
//     const url = response.config?.url || "";

//     if (isTokenRoute(url)) {
//       const token = extractTokenFromHeaders(response.headers);
//       if (token) {
//         persistAccessToken(token);
//         logger.log("Token saved successfully from:", url);
//       }
//     }

//     logger.log(`API Response: ${response.status} ${url}`);

//     const data: any = response.data;
//     if (isHasError(data)) {
//       logger.error("Interceptor detected hasError:", {
//         code: data.code,
//         message: data.message,
//         url,
//       });
//       return Promise.reject(
//         buildApiError(data, "خطایی رخ داد", response.status)
//       );
//     }

//     return response;
//   },
//   async (error) => {
//     const originalRequest = error?.config;

//     if (error?.message === "NO_INTERNET_CONNECTION") {
//       logger.warn("No internet connection");
//       return Promise.reject(
//         buildApiError(null, "اتصال اینترنت خود را بررسی کنید")
//       );
//     }

//     if (
//       error?.code === "ECONNABORTED" ||
//       error?.message?.includes("timeout")
//     ) {
//       logger.error("Request timeout:", originalRequest?.url);
//       return Promise.reject(
//         buildApiError(null, "درخواست زمان‌بر بود، لطفاً دوباره تلاش کنید")
//       );
//     }

//     if (error?.message === "Network Error") {
//       logger.error("Network error:", originalRequest?.url);
//       return Promise.reject(
//         buildApiError(null, "مشکل در ارتباط با سرور، لطفاً دوباره تلاش کنید")
//       );
//     }

//     if (
//       error?.response?.status === 401 &&
//       originalRequest &&
//       !originalRequest._retry
//     ) {
//       originalRequest._retry = true;
//       logger.log("Token expired, trying to refresh...");

//       try {
//         const res = await getNewTokens();
//         const newToken = res?.accessTokenCartStreet;

//         if (newToken) {
//           persistAccessToken(newToken);

//           if (res?.refreshToken) {
//             setCookie("refreshToken", res.refreshToken, 360);
//             if (typeof window !== "undefined") {
//               localStorage.setItem("refreshToken", res.refreshToken);
//             }
//           }

//           originalRequest.headers = originalRequest.headers || {};
//           originalRequest.headers["Authorization"] = `Bearer ${newToken}`;
//           logger.log("Token refreshed, retrying request");
//           return api(originalRequest);
//         }

//         throw new Error("NO_NEW_TOKEN");
//       } catch (refreshError) {
//         logger.error("Refresh token failed:", refreshError);
//         return Promise.reject(
//           buildApiError(
//             null,
//             "نشست شما منقضی شده است. لطفا دوباره وارد شوید"
//           )
//         );
//       }
//     }

//     // ============================================
//     // ✅ تشخیص Blob و استخراج JSON
//     // ============================================
//     let errorData = error?.response?.data;

//     if (isBlob(errorData)) {
//       const parsed = await parseBlobError(errorData);
//       errorData = parsed ?? null;
//     }

//     logger.error(
//       `API Error: ${error?.response?.status || "unknown"}`,
//       errorData || error.message
//     );

//     if (isHasError(errorData)) {
//       return Promise.reject(
//         buildApiError(errorData, "خطایی رخ داد", error?.response?.status)
//       );
//     }

//     return Promise.reject(
//       buildApiError(
//         errorData,
//         error?.message || "خطایی رخ داد",
//         error?.response?.status
//       )
//     );
//   }
// );

// export default api;

import axios from "axios";
import { getCookie, setCookie } from "../../../lib/cookie.js";

// ===== تنظیمات محیط =====
export const getBaseUrl = () => {
  if (import.meta.env.VITE_BASE_URL) {
    return import.meta.env.VITE_BASE_URL;
  }

  if (typeof window !== "undefined") {
    const hostname = window.location.hostname;

    if (hostname.includes("staging") || hostname.includes("test")) {
      return "/api";
    }

    if (hostname.includes("sharjdev") || hostname.includes("sharjstreet")) {
      return "/api";
    }
  }

  return "/api";
};

// ✅ 0 = بدون تایم‌اوت (هرچقدر طول کشید صبر می‌کنه)
const NO_TIMEOUT = 0;

export const ENV = {
  mode: import.meta.env.VITE_APP_ENV || import.meta.env.MODE || "development",
  isDevelopment:
    import.meta.env.VITE_APP_ENV === "development" || import.meta.env.DEV,
  isStaging: import.meta.env.VITE_APP_ENV === "staging",
  isProduction:
    import.meta.env.VITE_APP_ENV === "production" || import.meta.env.PROD,
  baseURL: getBaseUrl(),
  apiTimeout: parseInt(
    import.meta.env.VITE_API_TIMEOUT || String(NO_TIMEOUT)
  ),
  useProxy: import.meta.env.VITE_USE_PROXY === "true",
};

// ===== Logger =====
const logger = {
  log: (...args: any[]) => {
    if (!ENV.isProduction) console.log("");
  },
  error: (...args: any[]) => {
    if (!ENV.isProduction) console.error("");
  },
  warn: (...args: any[]) => {
    if (!ENV.isProduction) console.warn("");
  },
};

logger.log(`Base URL: ${ENV.baseURL}`);
logger.log(`Environment: ${ENV.mode}`);
logger.log(
  `API Timeout: ${ENV.apiTimeout === 0 ? "بدون محدودیت" : ENV.apiTimeout + " ms"}`
);

// ===== وضعیت اتصال =====
let isOnline = typeof navigator !== "undefined" ? navigator.onLine : true;

if (typeof window !== "undefined") {
  window.addEventListener("online", () => {
    isOnline = true;
    logger.log("Internet connection restored");
  });

  window.addEventListener("offline", () => {
    isOnline = false;
    logger.log("Internet connection lost");
  });
}

// ===== نمونه axios =====
const api = axios.create({
  baseURL: ENV.baseURL,
  timeout: ENV.apiTimeout, // 0 = بدون تایم‌اوت
  headers: { "Content-Type": "application/json" },
  withCredentials: true,
});

// ===== مسیرها =====
const publicRoutes = [
  "User/SendOtp",
  "User/ConfirmOtp",
  "customerPanel/login/sendOtp",
  "customerPanel/login/validateOTP",
  "/login-oranization",
  "/login-organization/forget-password",
  "/EnterOtp",
];

const tokenReturningRoutes = [
  "customerPanel/login/validateOTP",
  "managerPanel/login/super_admin",
  "customerPanel/legal/login/login",
];

// ===== ابزارهای داخلی =====
const buildApiError = (
  data: any,
  fallbackMessage?: string,
  status?: number
): Error => {
  const apiError: any = new Error(
    data?.message || fallbackMessage || "خطایی رخ داد"
  );
  apiError.response = {
    data: data ?? null,
    status: status ?? data?.code ?? null,
  };
  apiError.isApiError = true;
  apiError.originalData = data ?? null;
  apiError.code = data?.code ?? null;
  return apiError;
};

const isHasError = (data: any): boolean => {
  if (!data || typeof data !== "object") return false;
  const v = data.hasError;
  return v === true || v === 1 || v === "true" || v === "1";
};

// ✅ helper — تشخیص Blob
const isBlob = (v: any): v is Blob =>
  typeof Blob !== "undefined" && v instanceof Blob;

// ✅ helper — خواندن JSON داخل Blob
const parseBlobError = async (blob: Blob): Promise<any | null> => {
  try {
    const text = await blob.text();
    return JSON.parse(text);
  } catch {
    return null;
  }
};

const isPublicRoute = (url?: string) => {
  if (!url) return false;
  return publicRoutes.some((route) => url.includes(route));
};

const isTokenRoute = (url?: string) => {
  if (!url) return false;
  return tokenReturningRoutes.some((route) => url.includes(route));
};

const extractTokenFromHeaders = (headers: any): string | null => {
  const authHeader =
    headers?.["authorization"] || headers?.["Authorization"] || null;
  if (!authHeader || typeof authHeader !== "string") return null;
  let token = authHeader;
  if (token.startsWith("Bearer ")) token = token.substring(7);
  return token || null;
};

const persistAccessToken = (token: string) => {
  setCookie("accessTokenCartStreet", token, 30);
  if (typeof window !== "undefined") {
    localStorage.setItem("accessTokenCartStreet", token);
  }
};

const clearTokens = () => {
  setCookie("accessTokenCartStreet", "", -1);
  setCookie("refreshToken", "", -1);
  if (typeof window !== "undefined") {
    localStorage.removeItem("accessTokenCartStreet");
    localStorage.removeItem("refreshToken");
  }
};

const redirectToLogin = () => {
  if (typeof window !== "undefined") {
    window.location.replace("/login");
  }
};

// ===== دریافت توکن جدید =====
const getNewTokens = async () => {
  let refreshToken = getCookie("refreshToken");
  if (!refreshToken && typeof window !== "undefined") {
    refreshToken = localStorage.getItem("refreshToken") || "";
  }

  if (!refreshToken) {
    logger.warn("No refresh token found");
    return {};
  }

  try {
    const response = await axios.post(
      `${ENV.baseURL}/auth/refresh-token`,
      { refresh_token: refreshToken },
      {
        timeout: NO_TIMEOUT, // ✅ بدون تایم‌اوت
        headers: { "Content-Type": "application/json" },
        withCredentials: true,
      }
    );

    logger.log("New tokens received successfully");

    const data = response?.data || {};
    const authHeader = extractTokenFromHeaders(response.headers);
    const accessTokenCartStreet =
      data?.accessTokenCartStreet || data?.accessToken || authHeader || null;

    return {
      accessTokenCartStreet,
      refreshToken: data?.refreshToken || null,
    };
  } catch (error) {
    logger.error("Refresh token error:", error);
    return {};
  }
};

// ===== اینترسپتور درخواست =====
api.interceptors.request.use(
  (config: any) => {
    if (!isOnline) {
      logger.warn("No internet connection for request:", config.url);
      return Promise.reject(new Error("NO_INTERNET_CONNECTION"));
    }

    let accessTokenCartStreet = getCookie("accessTokenCartStreet");
    if (!accessTokenCartStreet && typeof window !== "undefined") {
      accessTokenCartStreet =
        localStorage.getItem("accessTokenCartStreet") || "";
    }

    const isPublic = isPublicRoute(config.url);

    if (!isPublic && accessTokenCartStreet) {
      config.headers["Authorization"] = `Bearer ${accessTokenCartStreet}`;
    }

    logger.log(`API Request: ${config.method?.toUpperCase()} ${config.url}`);

    return config;
  },
  (error) => {
    logger.error("Request interceptor error:", error);
    return Promise.reject(error);
  }
);

// ===== اینترسپتور پاسخ =====
api.interceptors.response.use(
  (response) => {

    const url = response.config?.url || "";

    if (isTokenRoute(url)) {
      const token = extractTokenFromHeaders(response.headers);
      if (token) {
        persistAccessToken(token);
        logger.log("Token saved successfully from:", url);
      }
    }

    logger.log(`API Response: ${response.status} ${url}`);

    const data: any = response.data;
    if (isHasError(data)) {
      logger.error("Interceptor detected hasError:", {
        code: data.code,
        message: data.message,
        url,
      });
      return Promise.reject(
        buildApiError(data, "خطایی رخ داد", response.status)
      );
    }

    return response;
  },
  async (error) => {
    const originalRequest = error?.config;
   
    if (error?.message === "NO_INTERNET_CONNECTION") {
      logger.warn("No internet connection");
      return Promise.reject(
        buildApiError(null, "اتصال اینترنت خود را بررسی کنید")
      );
    }

    // ⚠️ این بلوک دیگه اجرا نمی‌شه چون timeout=0 (ولی برای امنیت نگه داشتم)
    if (
      error?.code === "ECONNABORTED" ||
      error?.message?.includes("timeout")
    ) {
      logger.error("Request timeout:", originalRequest?.url);
      return Promise.reject(
        buildApiError(null, "درخواست زمان‌بر بود، لطفاً دوباره تلاش کنید")
      );
    }

    if (error?.message === "Network Error") {
      logger.error("Network error:", originalRequest?.url);
      return Promise.reject(
        buildApiError(null, "مشکل در ارتباط با سرور، لطفاً دوباره تلاش کنید")
      );
    }

    if (
      error?.response?.status === 401 &&
      originalRequest &&
      !originalRequest._retry
    ) {
      originalRequest._retry = true;
      logger.log("Token expired, trying to refresh...");

      try {
        const res = await getNewTokens();
        const newToken = res?.accessTokenCartStreet;

        if (newToken) {
          persistAccessToken(newToken);

          if (res?.refreshToken) {
            setCookie("refreshToken", res.refreshToken, 360);
            if (typeof window !== "undefined") {
              localStorage.setItem("refreshToken", res.refreshToken);
            }
          }

          originalRequest.headers = originalRequest.headers || {};
          originalRequest.headers["Authorization"] = `Bearer ${newToken}`;
          logger.log("Token refreshed, retrying request");
          return api(originalRequest);
        }

        throw new Error("NO_NEW_TOKEN");
      } catch (refreshError) {
        logger.error("Refresh token failed:", refreshError);
        return Promise.reject(
          buildApiError(
            null,
            "نشست شما منقضی شده است. لطفا دوباره وارد شوید"
          )
        );
      }
    }

    // ============================================
    // ✅ تشخیص Blob و استخراج JSON
    // ============================================
    let errorData = error?.response?.data;

    if (isBlob(errorData)) {
      const parsed = await parseBlobError(errorData);
      errorData = parsed ?? null;
    }

    logger.error(
      `API Error: ${error?.response?.status || "unknown"}`,
      errorData || error.message
    );

    if (isHasError(errorData)) {
      return Promise.reject(
        buildApiError(errorData, "خطایی رخ داد", error?.response?.status)
      );
    }

    return Promise.reject(
      buildApiError(
        errorData,
        error?.message || "خطایی رخ داد",
        error?.response?.status
      )
    );
  }
);

export default api;